import React from "react";

import { Box, Typography } from "@mui/material";
import AlertMessage from "../../../Common/Alert/AlertMessage";

const ListCategories = ({ categories }) => {
    return (
        <>
            {categories?.length > 0 ? (
                <>
                    {categories
                        .sort((a, b) => a.name?.localeCompare(b.name) || 0)
                        .map((data) => (
                            <Box className="card-content" key={data.id}>
                                <Typography variant="h3" component="h3">
                                    {data?.name}
                                </Typography>
                                <CategoryListChildren
                                    categories={data.children}
                                />
                            </Box>
                        ))}
                </>
            ) : (
                <AlertMessage
                    severity={"info"}
                    message={"No categories found"}
                />
            )}
        </>
    );
};

const CategoryListChildren = ({ categories }) => {
    return (
        <Box className="card-content">
            {categories?.length > 0 &&
                categories
                    .sort((a, b) => a.name?.localeCompare(b.name) || 0)
                    .map((data) => (
                        <Box className="card-content" key={data.id}>
                            <Typography variant="body1">
                                {data?.name}
                            </Typography>
                        </Box>
                    ))}
        </Box>
    );
};

export default ListCategories;
